// src/components/Header/Header.tsx
import React from 'react';
import styles from './Header.module.css';
import { UserAvatar } from '../UserAvatar';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Button } from '@mui/material';
import { Logout } from '@mui/icons-material';

// 2. Crie um mapa de caminhos para os textos dos breadcrumbs
const breadcrumbMap: { [key: string]: string } = {
  '/finances': 'Finanças',
  '/relatorios': 'Relatórios',
  '/profile': 'Perfil',
};

interface HeaderProps {
  onToggleSidebar: () => void;
}

export function Header({ onToggleSidebar }: HeaderProps) {
  // 3. Use o hook para pegar a localização atual
  const location = useLocation();
  const { user, logout } = useAuth();

  // 4. Procure o texto do breadcrumb no mapa usando o pathname atual
  const pageTitle = breadcrumbMap[location.pathname] || 'Página Inicial';
  const breadcrumbText = `Home > ${pageTitle}`;

  const handleLogout = () => {
    logout();
  };

  // Debug silencioso

  return (
    <header className={styles.header}>
      <div className={styles.leftSection}>
        <button 
          className={styles.menuButton} 
          onClick={onToggleSidebar}
          aria-label="Toggle sidebar"
        >
          ☰
        </button>
        {/* 5. Renderize o breadcrumb dinâmico */}
        <div className={styles.breadcrumbs}>
          {breadcrumbText}
        </div>
      </div>
      <div className={styles.userActions}>
        <UserAvatar />
        <Button
          variant="outlined"
          size="small"
          startIcon={<Logout />}
          onClick={handleLogout}
          className={styles.logoutButton}
        >
          Sair
        </Button>
      </div>
    </header>
  );
}